import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BACKBONE_URL } from '../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private httpClient: HttpClient) { }

  public getLocations() {
    let address = BACKBONE_URL + `Location`;
    return this.httpClient.get(address);
  }
}
